import { HTTPError } from "ky";
import { isNull, omitBy } from "lodash";
import { ApiResponse, api, requestHeaders } from ".";
import { errorMonitor } from "../error-monitor/sentry/errorMonitor";
import { sessionStore } from "./../../util/browser-storage/index";
import { ApiRequestParams } from "./type";

export async function logError(error: HTTPError) {
  if (error) {
    const reqUrl = new URL(error.request.url);
    error.name = `APIError - ${error.request.method} - ${reqUrl.pathname}`;
    errorMonitor.logError(error, {
      requestUrl: error.request.url,
      requestMethod: error.request.method,
      responseStatus: error.response.status,
    });
  }
  return error;
}
export async function apiRequest<TData, TResponse>(
  params: ApiRequestParams<TData>
): Promise<ApiResponse<TResponse>> {
  const id = sessionStore.getItem("customer_id") as string;

  const headers: requestHeaders = omitBy(
    {
      "GFIN-PORTAL-CUSTOMER-ID": id,
    },
    isNull
  );

  switch (params.method) {
    case "POST":
      return await api.post(`${params.url}`, {
        json: params.data,
        searchParams: params.searchParams,
        headers,
      });
    case "PUT":
      return await api.put(`${params.url}`, {
        json: params.data,
        searchParams: params.searchParams,
        headers,
      });
    case "PATCH":
      return await api.patch(`${params.url}`, {
        json: params.data,
        searchParams: params.searchParams,
        headers,
      });
    case "DELETE":
      return await api.delete(`${params.url}`, {
        searchParams: params.searchParams,
        headers,
      });
    default:
      return await api.get(`${params.url}`, {
        searchParams: params.searchParams,
        headers,
      });
  }
}
